module.exports = __webpack_public_path__ + "img/button_up.654f4252.png";